import { QueryClient } from "@tanstack/react-query";

// ADMIN_PANEL_ARCHITECTURE_TEMPLATE.md §11, verbatim.
//
// staleTime 60s matches the backend's own dashboard memo (DASHBOARD_CACHE_SECONDS_DEFAULT), so the
// client and the server agree on what "fresh" means. Within 60s, navigating away and back is instant
// from cache with no request at all; after that the cached data still renders immediately and a
// background refetch updates it when it lands.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      gcTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false, // a report dashboard has ~10 mounted queries; alt-tab must not refetch all of them

      // ── A 4xx IS AN ANSWER, NOT A FAILURE TO RETRY ───────────────────────────
      // WAS `retry: 1` unconditionally, which retried 404s, 403s and 422s — none of which can
      // succeed on a second attempt, because each is the server's considered verdict.
      //
      // THE COST WAS A MISLEADING SCREEN, not just a wasted request. Between the failed attempt and
      // its retry, React Query reports `isLoading: false`, `isError: false` and `data: undefined`,
      // so a page renders its error state with NO error to show — and the reader is told
      // "Something went wrong" where the server had said "Employee not found". Browser testing
      // during Registration & Sales Part 1 caught exactly that on a deep link to a bad id.
      //
      // A 5xx, a timeout and a dropped connection ARE transient, and those still get their retry.
      // 401 is not reached here: the axios interceptor redirects to /login before a query sees it.
      retry: (failureCount, error) => {
        const status = error?.response?.status;
        if (status >= 400 && status < 500) return false;
        return failureCount < 1;
      },
    },
  },
});
